import { Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const UserAvatar = ({ size = 'md', showTooltip = true }) => {
  const { currentUser, userProfile } = useAuth();
  
  const sizeClasses = {
    sm: 'w-8 h-8 text-sm',
    md: 'w-10 h-10 text-lg',
    lg: 'w-20 h-20 text-3xl'
  };
  
  const displayName = userProfile?.displayName || currentUser?.displayName || 'User';
  const initial = displayName.charAt(0).toUpperCase();
  
  if (!currentUser) return null;
  
  return (
    <Link
      to="/dashboard"
      className="group relative"
      title={showTooltip ? `Go to Dashboard (${displayName})` : undefined}
    >
      <div className={`${sizeClasses[size]} bg-gradient-to-br from-primary-500 to-primary-700 rounded-full flex items-center justify-center text-white font-bold hover:from-primary-600 hover:to-primary-800 transition-all duration-200 hover:scale-105 shadow-sm hover:shadow-md`}>
        {initial}
      </div>
      {showTooltip && (
        <div className="absolute bottom-full left-1/2 transform -translate-x-1/2 mb-2 px-2 py-1 bg-gray-900 text-white text-xs rounded opacity-0 group-hover:opacity-100 transition-opacity duration-200 whitespace-nowrap pointer-events-none">
          Dashboard
        </div>
      )}
    </Link>
  );
};

export default UserAvatar;